module.exports = __webpack_public_path__ + "img/DE02675.713d85ed.png";